import { api } from './client.js';

export const getCandidateLinks = async () => {
  return api.get('/company/candidate-links');
};

export const createCandidateLink = async (payload) => {
  return api.post('/company/candidate-links', payload);
};

export const updateCandidateLinkStatus = async (id, status) => {
  return api.patch(`/company/candidate-links/${id}/status`, { status });
};

export const deleteCandidateLink = async (id) => {
  return api.delete(`/company/candidate-links/${id}`);
};

export const getPublicCandidateLink = async (token) => {
  return api.get(`/public/candidate-links/${token}`, {
    cache: 'no-store',
  });
};

export const submitPublicCandidateForm = async (token, payload, resumeFile = null) => {
  if (resumeFile instanceof File) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(payload));
    formData.append('resume', resumeFile);
    return api.post(`/public/candidate-links/${token}/submit`, formData);
  }
  return api.post(`/public/candidate-links/${token}/submit`, payload);
};
